/* eslint-disable @typescript-eslint/restrict-template-expressions */
import axios from 'axios';

const usePostUpload = () => {
	// title: string, file: File
	const fetchUpload = async (url: string, formData: FormData) => {
		try {
			await axios.post(
				// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
				url,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
						Authorization: `Bearer ${localStorage.getItem('Token')}`,
						refreshToken: `Bearer ${localStorage.getItem('Refresh-Token')}`,
					},
				},
			);
		} catch (error: unknown) {
			if (error instanceof axios.AxiosError) {
				if (error.response) {
					throw error;
				} else {
					throw new Error('Connection error. Please try again.');
				}
			}
			throw new Error('Unexpected error');
		}
	};

	return {
		fetchUpload,
	};
};

export default usePostUpload;
